export default {
  page: {
    title: 'Separador de palabras',
    subtitle: 'Herramientas',
  },
  card: {
    title: 'Separador de palabras',
  },
  form: {
    text: {
      label: 'Pegue el texto aquí',
      placeholder: '',
    },
    variations: {
      label: 'Generar varios',
      option: 'Sí',
    },
    result: {
      label: 'Texto generado',
      placeholder: 'El texto generado aparecerá aquí',
    },
    repeatedWords: {
      label: 'Palabras repetidas:',
    },
    totalWords: {
      label: 'Total de palabras:',
    },
  },
  table: {
    group: 'Grupo',
    repeatedWords: 'Palabras repetidas',
    totalWords: 'Total de palabras',
    noContent: 'Todavía no hay ningún texto generado.',
  },
  alert: {
    repeatedWord: '¡Palabra repetida!',
  },
};
